import React, {useState} from "react"
import {FieldEditableMode, FieldEditableProps} from "../../../../../proto/render/editable";
import FieldToggle_Component from "../../components/toggle-stateless";
import {ToggleSize} from "../../components/toggle-statefull";
import {isBulkSelection} from "../../../../../../gd/right-click-menu";

const debug = false
// const debug = "FieldToggle_Editable"

export default function FieldToggle_Editable(props:FieldEditableProps) {

    const canEdit = props.field.canEdit(props.model)

    const [mode, setMode] = useState(FieldEditableMode.VIEW)

    const onMouseEnter = () => {
        if (!canEdit) return false

        if (mode === FieldEditableMode.VIEW) {
            setMode(FieldEditableMode.HOVERED)
        }
    }

    const onMouseLeave = () => {
        if (FieldEditableMode.HOVERED) setMode(FieldEditableMode.VIEW)
    }

    const value = props.field.getViewValue(props.model)

    const toggleValue = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!canEdit) return

        onChange(!value)
    }

    const onChange = (value:any) => {
        if (props.disabled || !canEdit) return false

        props.onChange && props.onChange(value)
    }

    const classes = Classes("ui5-field-editable w-100-percent h-100-percent", "size-small", props.className, {
        'is-hovered': mode === FieldEditableMode.HOVERED
    })

    return (
        <div className={classes} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <FieldToggle_Component size    = {ToggleSize.SIZE_16}
                                   value   = {value}
                                   onClick = {toggleValue}/>
        </div>
    )
}
